/* global axios */
import ApiClient from '../ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  get({
    inboxId,
    status,
    assigneeType,
    page,
    labels,
    teamId,
    conversationType,
    sortBy,
    updatedWithin,
    q,
    // BonBoZ: cac nut loc nhanh o thanh trai. Xem `Conversations::QuickFilter`.
    unseen,
    unlabeled,
    hasPhone,
    fromAd,
    assigneeId,
    activityAfter,
    activityBefore,
    dateField,
    searchMode,
    labelMatch,
  }) {
    return axios.get(this.url, {
      params: {
        inbox_id: inboxId,
        team_id: teamId,
        status,
        assignee_type: assigneeType,
        page,
        labels,
        conversation_type: conversationType,
        sort_by: sortBy,
        updated_within: updatedWithin,
        // BonBoZ: tu khoa tim. `search_mode` chon tang: bo trong = danh tinh
        // (ten, SDT, ma hoi thoai), 'content' = noi dung tin nhan.
        q,
        unseen,
        unlabeled,
        has_phone: hasPhone,
        from_ad: fromAd,
        assignee_id: assigneeId,
        activity_after: activityAfter,
        activity_before: activityBefore,
        date_field: dateField,
        search_mode: searchMode,
        label_match: labelMatch,
      },
    });
  }

  filter(payload) {
    return axios.post(`${this.url}/filter`, payload.queryData, {
      params: {
        page: payload.page,
      },
    });
  }

  search({ q }) {
    return axios.get(`${this.url}/search`, {
      params: {
        q,
        page: 1,
      },
    });
  }

  toggleStatus({ conversationId, status, snoozedUntil = null }) {
    return axios.post(`${this.url}/${conversationId}/toggle_status`, {
      status,
      snoozed_until: snoozedUntil,
    });
  }

  togglePriority({ conversationId, priority }) {
    return axios.post(`${this.url}/${conversationId}/toggle_priority`, {
      priority,
    });
  }

  assignAgent({ conversationId, agentId, assigneeType }) {
    return axios.post(`${this.url}/${conversationId}/assignments`, {
      assignee_id: agentId,
      assignee_type: assigneeType,
    });
  }

  assignTeam({ conversationId, teamId }) {
    const params = { team_id: teamId };
    return axios.post(`${this.url}/${conversationId}/assignments`, params);
  }

  markMessageRead({ id }) {
    return axios.post(`${this.url}/${id}/update_last_seen`);
  }

  markMessagesUnread({ id }) {
    return axios.post(`${this.url}/${id}/unread`);
  }

  toggleTyping({ conversationId, status, isPrivate }) {
    return axios.post(`${this.url}/${conversationId}/toggle_typing_status`, {
      typing_status: status,
      is_private: isPrivate,
    });
  }

  mute(conversationId) {
    return axios.post(`${this.url}/${conversationId}/mute`);
  }

  unmute(conversationId) {
    return axios.post(`${this.url}/${conversationId}/unmute`);
  }

  // BonBoZ: so dem tren cac tab phai dem TREN CUNG bo dieu kien voi danh sach,
  // neu khong tab bao 40 ma danh sach ra 3 va khong ai biet tin cai nao.
  meta({
    inboxId,
    status,
    assigneeType,
    labels,
    teamId,
    conversationType,
    unseen,
    unlabeled,
    hasPhone,
    fromAd,
    assigneeId,
    activityAfter,
    activityBefore,
    dateField,
    searchMode,
    labelMatch,
  }) {
    return axios.get(`${this.url}/meta`, {
      params: {
        inbox_id: inboxId,
        status,
        assignee_type: assigneeType,
        labels,
        team_id: teamId,
        conversation_type: conversationType,
        unseen,
        unlabeled,
        has_phone: hasPhone,
        from_ad: fromAd,
        assignee_id: assigneeId,
        activity_after: activityAfter,
        activity_before: activityBefore,
        date_field: dateField,
        search_mode: searchMode,
        label_match: labelMatch,
      },
    });
  }

  sendEmailTranscript({ conversationId, email }) {
    return axios.post(`${this.url}/${conversationId}/transcript`, { email });
  }

  updateCustomAttributes({ conversationId, customAttributes }) {
    return axios.post(`${this.url}/${conversationId}/custom_attributes`, {
      custom_attributes: customAttributes,
    });
  }

  fetchParticipants(conversationId) {
    return axios.get(`${this.url}/${conversationId}/participants`);
  }

  updateParticipants({ conversationId, userIds }) {
    return axios.patch(`${this.url}/${conversationId}/participants`, {
      user_ids: userIds,
    });
  }

  getAllAttachments(conversationId) {
    return axios.get(`${this.url}/${conversationId}/attachments`);
  }

  getInboxAssistant(conversationId) {
    return axios.get(`${this.url}/${conversationId}/inbox_assistant`);
  }

  delete(conversationId) {
    return axios.delete(`${this.url}/${conversationId}`);
  }
}

export default new ConversationApi();
